const baseUrl = "https://backend.dealboxx.promo/api/admin";
const promoApiBase = "https://backend.dealboxx.promo/api";

const Config = {
  baseUrl: baseUrl,
  promoApiBase: promoApiBase,
};

export default Config;
